import { z } from 'zod/v4';

import { copilotRequestSchema } from './copilot-request.schema';

export const copilotRequestPagedCollectionSchema = z.object({
  totalCount: z.number(),
  data: z.array(copilotRequestSchema),
});

export type CopilotRequestPagedCollection = z.infer<
  typeof copilotRequestPagedCollectionSchema
>;
